import React, { useEffect, useState } from 'react';
import { CharacterList } from '../../components/load-character/char-list';

export const SelectCharacter: React.FC = (): JSX.Element => {
    return(
       <CharacterList/>
    )
}